import React from 'react';
import {FmlxButton, FmlxModal} from 'fmlx-common-ui';

const ConfirmationModal = ({open, confirmationMessage, onClose, savedPayload, onSend}) => {
  const handleConfirm = () => {
    if (!savedPayload) {
      console.error('No payload saved for discard.');
      return;
    }

    const discardPayload = {
      ...savedPayload,
      confirmation: true,
    };
    onSend(discardPayload);
    if (onClose) onClose();
  };

  const handleCancel = () => {
    if (onClose) onClose();
  };

  return (
    <FmlxModal
      open={open}
      size={FmlxModal.Size.MEDIUM}
      title="Confirmation Needed"
      onCloseClick={onClose}
      customFooter={
        <div className="modal-footer">
          <FmlxButton label="Cancel" type="primary" variant="outline" onClick={handleCancel}/>
          <FmlxButton label="Confirm" type="secondary" variant="contain" onClick={handleConfirm}/>
        </div>
      }
    >
      <div className="modal-content">
        <div style={{padding: '20px'}}>
          <p>{confirmationMessage}</p>
        </div>
      </div>
    </FmlxModal>
  );
};

export default ConfirmationModal;
